import { atom } from 'jotai';

export const parcelSelectionAtom = atom<Set<number>>(new Set<number>());
